import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('offgrid');
    const [open, setOpen] = useState(false);
    const { locale } = useRouter();
    const tableData: any = {
        thead: [t('secD_table_head_item1'), t('secD_table_head_item2'), t('secD_table_head_item3'), t('secD_table_head_item4')],
        tbody: [
            [t('secD_table_content_row1_col1'), t('secD_table_content_row1_col2'), t('secD_table_content_row1_col3'), t('secD_table_content_row1_col4')],
            [t('secD_table_content_row2_col1'), t('secD_table_content_row2_col2'), t('secD_table_content_row2_col3'), t('secD_table_content_row2_col4')],
            [t('secD_table_content_row3_col1'), t('secD_table_content_row3_col2'), t('secD_table_content_row3_col3'), t('secD_table_content_row3_col4')],
            [t('secD_table_content_row4_col1'), t('secD_table_content_row4_col2'), t('secD_table_content_row4_col3'), t('secD_table_content_row4_col4')],
            [t('secD_table_content_row5_col1'), t('secD_table_content_row5_col2'), t('secD_table_content_row5_col3'), t('secD_table_content_row5_col4')],
            [t('secD_table_content_row6_col1'), t('secD_table_content_row6_col2'), t('secD_table_content_row6_col3'), t('secD_table_content_row6_col4')],
            [t('secD_table_content_row7_col1'), t('secD_table_content_row7_col2'), t('secD_table_content_row7_col3'), t('secD_table_content_row7_col4')],
            [t('secD_table_content_row8_col1'), t('secD_table_content_row8_col2'), t('secD_table_content_row8_col3'), t('secD_table_content_row8_col4')],
            [t('secD_table_content_row9_col1'), t('secD_table_content_row9_col2'), t('secD_table_content_row9_col3'), t('secD_table_content_row9_col4')],
            [t('secD_table_content_row10_col1'), t('secD_table_content_row10_col2'), t('secD_table_content_row10_col3'), t('secD_table_content_row10_col4')],
        ],
    };
    const { thead, tbody } = tableData;

    return (
        <div id="off-grid-D" className={`off-grid-D off-grid-box inner ${css['off-grid-D']}`}>
            <h2 className="title">{t('secD_title')}</h2>
            <div className={`table-box  ${open ? 'open' : ''}`}>
                <table className={`table`}>
                    <thead className="thead">
                        <tr className="tr head-tr">
                            {thead?.map((c: any, k: number) => (
                                <th className="td th" key={k}>
                                    {c}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {tbody?.map((row: any, r: number) => (
                            <tr className="tr" key={r}>
                                {row?.map((col: any, c: number) => (
                                    <td className={`td ${c > 1 ? 's' : ''}`} key={`${r}_` + `${c}`}>
                                        {col}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button className="btn" aria-label={t('secD_btn')} onClick={() => setOpen(!open)}>
                <span className="btn-text">{t(open ? 'secD_btn_less' : 'secD_btn')}</span>
                <span className="btn-icon">
                    {open ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path
                                d="M10.5026 2.33301C12.6195 2.33301 14.5362 3.19125 15.9236 4.57869C17.311 5.96613 18.1693 7.88278 18.1693 9.99967C18.1693 12.1166 17.311 14.0332 15.9236 15.4207C14.5362 16.8081 12.6195 17.6663 10.5026 17.6663C8.38571 17.6663 6.46906 16.8081 5.08162 15.4207C3.69418 14.0332 2.83594 12.1166 2.83594 9.99967C2.83594 7.88278 3.69418 5.96613 5.08162 4.57869C6.46906 3.19125 8.38571 2.33301 10.5026 2.33301Z"
                                stroke="black"
                                strokeWidth="1.33333"
                            />
                            <path d="M13.8307 10H7.16406" stroke="black" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M10.0026 2.33301C12.1195 2.33301 14.0362 3.19125 15.4236 4.57869C16.811 5.96613 17.6693 7.88278 17.6693 9.99967C17.6693 12.1166 16.811 14.0332 15.4236 15.4207C14.0362 16.8081 12.1195 17.6663 10.0026 17.6663C7.88571 17.6663 5.96906 16.8081 4.58162 15.4207C3.19418 14.0332 2.33594 12.1166 2.33594 9.99967C2.33594 7.88278 3.19418 5.96613 4.58162 4.57869C5.96906 3.19125 7.88571 2.33301 10.0026 2.33301Z"
                                stroke="black"
                                strokeWidth="1.33333"
                            />
                            <path d="M10 6.66699V13.3337" stroke="black" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M13.3307 10H6.66406" stroke="black" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                </span>
            </button>
        </div>
    );
}
